<div class="dataActionCardDs__cont">
  <ng-container *ngIf="data?.length">
    <app-ds-generic-card
      class="dataActionCardDs__generic-card"
      [space]="genericCardSpace">
      <button
        class="dataActionCardDs__card dataActionCardDs__card--data dataActionCardDs__card--{{style}} stronger"
        aria-label="dataActionCardDs--card">
        <ng-container *ngFor="let item of data; trackBy: trackById; last as isLast; index as i">
          <div class="dataActionCardDs__card-cont dataActionCardDs__card-cont--data" (click)="clickEventTrigger(item)">
            <ng-container *ngTemplateOutlet="cardInfo; context: { info: item }"></ng-container>
            <ng-container *ngIf="item?.ActionIcon">
              <div class="dataActionCardDs__action">
                <app-ds-icon
                  [icon]="item?.ActionIcon"
                  [color]="iconFillColor.Primary"
                  [size]="20">
                </app-ds-icon>
              </div>
            </ng-container>
          </div>
          <div class="dataActionCardDs__divider" *ngIf="!isLast">
            <app-ds-divider></app-ds-divider>
          </div>
        </ng-container>
      </button>
    </app-ds-generic-card>
  </ng-container>
  <ng-container *ngIf="actions?.length">
    <div *ngFor="let action of actions; trackBy: trackById; index as i; first as isFirst; last as isLast" [style.margin-top]="topByAction(isFirst)">
      <button
        class="dataActionCardDs__card dataActionCardDs__card--action dataActionCardDs__card--action-{{getActionFailedType(action)}}"
        aria-label="dataActionCardDs--card"
        [class.first-without-data]="isFirstWithoutData(isFirst)"
        [class.last]="isLast"
        [class.only-one-action]="onlyOneAction"
        (click)="clickEventTrigger(action)">
        <div class="dataActionCardDs__card-cont">
          <ng-container *ngTemplateOutlet="cardInfo; context: { info: action?.Data ?? action, isAction: true }"></ng-container>
          <ng-container *ngIf="action?.ActionIcon && !action?.Data">
            <div class="dataActionCardDs__action">
              <app-ds-icon
                [icon]="action?.ActionIcon"
                [color]="getIconColor(action, true)"
                [size]="20">
              </app-ds-icon>
            </div>
          </ng-container>
        </div>
      </button>
    </div>
  </ng-container>
</div>

<ng-template #cardInfo let-info="info" let-isAction="isAction">
  <div class="dataActionCardDs__info">
    <ng-container *ngIf="info?.DataIcon">
      <div class="dataActionCardDs__info-icon">
        <app-ds-icon
          [icon]="info.DataIcon"
          [color]="getIconColor(info, isAction)"
          [size]="24">
        </app-ds-icon>
      </div>
    </ng-container>
    <div class="dataActionCardDs__info-text">
      <div class="dataActionCardDs__info-text-title">
        <ng-container *ngIf="info?.Title">
          <app-ds-typography
            [size]="fontSize.XXS"
            [fontFamily]="titleFontFamily"
            [color]="getFontColor(info, isAction, false)"
            [ellipsis]="true"
            [text]="info?.Title">
          </app-ds-typography>
        </ng-container>
      </div>
      <ng-container *ngIf="info?.Subtitle">
        <div class="dataActionCardDs__info-text-subtitle">
          <app-ds-typography
            [size]="fontSize.XXS"
            [color]="getFontColor(info, isAction, true)"
            [ellipsis]="true"
            [text]="info?.Subtitle">
          </app-ds-typography>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>